import { forwardRef, type Ref, type SVGProps } from "react";
const IconQuoteOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M16 2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14A14 14 0 0 0 16 2m0 2c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M15.273 17.867q0 1.444-.99 2.455t-2.43 1.011q-1.73 0-2.79-1.21Q8 18.915 8 16.929q0-1.95.486-3.323t1.386-2.202 2.214-1.228a9.4 9.4 0 0 1 2.008-.36c.55-.043.999.41.999.963 0 .617-.343 1.14-.998 1.23-1.365.187-2.68.964-3.065 2.344-.032.118.149.25.264.21q.27-.09.558-.09 1.584 0 2.503.993.918.993.918 2.402m8 0q0 1.444-.99 2.455t-2.43 1.011q-1.73 0-2.79-1.21Q16 18.915 16 16.929q0-1.95.468-3.323t1.386-2.202c1.037-.939 2.459-1.451 4.24-1.588.55-.043.999.41.999.963 0 .617-.343 1.14-.997 1.23-1.383.19-2.696.94-3.068 2.344-.031.117.15.25.266.21q.27-.09.558-.09 1.584 0 2.503.993.918.993.918 2.402"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconQuoteOutlineSVG);
ForwardRef.displayName = "IconQuoteOutline";
export { ForwardRef as IconQuoteOutline };
